import { notifyServiceContractsUpdated } from './notifyServiceContractsUpdated'

export default {
  notifyServiceContractsUpdated
}
